module.exports = __webpack_public_path__ + "static/img/1958_09_23_RheinischePost.931487e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_23_RheinischePost.jpg
// module id = 0SWl
// module chunks = 0